import React from 'react'
import SelectList from './select'

const available = ({ available_actions }) =>
  (available_actions || []).includes('activate_service_reg')

const validate = ({ reg_holder_id }) => reg_holder_id

// eslint-disable-next-line react/display-name
const activateForm = record => ({ onChange }) => (
  <fieldset>
    <SelectList record={record} onChange={onChange} />
  </fieldset>
)

const apiEndPoint = ({ gov_id }) =>
  process.env.REACT_APP_API_HOST + `/api/service-registrations/${gov_id}/registration-holders`

const activate = ({ record }) =>
  available(record)
    ? {
        label: 'Activate',
        value: 'activate_service_reg',
        component: activateForm(record),
        url: apiEndPoint(record),
        validate,
      }
    : null

export default activate



// WEBPACK FOOTER //
// ./src/providers-registrations/service-list/activate-action/index.js